module.exports = __webpack_public_path__ + "img/star2-10.d198ab1b.svg";